
import CONFIG from '../../config'

const getParamsCreate = function(params: any) {
  const {
    action,
    method,
    apiKey,
    sessionId,
    company,
    companyId,
    operationId,
    personalNumber,
    number,
    cellphone,
    email
  } = params

  return {
    action,
    method,
    apiKey,
    sessionId,
    company,
    companyId,
    operationId,
    baseUrl: "",
    useFingerprint: false,
    usePin: false,
    pinRestore: false,
    pinRestoreMethod: "",
    language: "",
    facingMode: "",
    updatePerson: true,
    operator: {
      useFingerprint: false,
      usePin: false,
      pinRestore: false,
      pinRestoreMethod: "",
      sessionId: "",
      identityDocument: {
        countryCode: "",
        type: "",
        personalNumber: ""
      }
    },
    digitalIdentity: {
      personalData: {
        givenNames: "Clinica",
        surnames: "INDISA",
        dob: 20000101,
        gender: "NOT_KNOWN"
      },
      emailAddresses: [
        {
          type: "BUSINESS",
          address: "portal@indisa.cl",
          primary: false
        },
        {
          type: "PERSONAL",
          address: email,
          primary: true
        }
      ],
      contactPhones: [
        {
          number: cellphone,
          primary: true,
          type: "MOBILE",
          countryCode: 56,
          areaCode: 9
        }
      ],
      identityDocuments: [{
        countryCode: "CL", /* Mandatory for almost any process */
        type: "ID", /* Mandatory for almost any process */
        personalNumber, /* Mandatory for almost any process */
        number,
        issueDate: "",
        expiryDate: "",
        issuingAuthority: "",
        issuePlace: "",
        nationality: "CHL"
      }]
    }
  }
}

const openCheckId = function(origin: string = '') {
  // Create popup window
  let popupPage: any
  const w = 1024
  const h = 640
  const isNewTab = false

  // Fixes dual-screen position Most browsers Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : (window as any).screen.left
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : (window as any).screen.top

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : (window as any).width
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : (window as any).height

  const left = ((width / 2) - (w / 2)) + dualScreenLeft
  const top = ((height / 2) - (h / 2)) + dualScreenTop

  const options = 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left
  const lOrigin: string = `${origin}`

  if(isNewTab) {
    // open component in a new Tab
    popupPage = window.open(lOrigin)
  } else {
    // open component like a Popup
    popupPage = window.open(lOrigin, 'CheckID', options)
  }

  return popupPage
}

export const solem = {
  getParamsCreate,
  openCheckId
}